const usersEn = {
    profile: require('lang/en/users/Profile').default,
    user: require('lang/en/users/User').default,
    premiseUser: require('lang/en/users/PremiseUser').default,
    serviceProvider: require('lang/en/users/ServiceProvider').default,
    staffAttendance: require('lang/en/users/StaffAttendance').default,
    premiseUserAttendance: require('lang/en/users/PremiseUserAttendance').default,
    changeRequest: require('lang/en/users/ChangeRequest').default,
};

export default usersEn;